import React = require("react");
import "./EquipmentStockLevel.scss";

interface UsageBarProps {
    capacity: number;
    currentValue: number;
    currentValuePercentage;
    unitOfMeasure?: string;
}

const colors = ["#FC594D", "#FFBC42", "#dede6dfc", "#8ce7c7", "#00C399"];
export const UsageBar: React.FunctionComponent<UsageBarProps> = (props) => {
    if (props.capacity == null || props.currentValue == null) {
        return null;
    }

    const getColor = (perc) => {
        if (perc === 100) {
            return "#00C399"
        }
        if (perc >= 75) {
            return "#8ce7c7";
        }
        if (perc >= 50) {
            return "#dede6dfc";
        }
        if (perc >= 25) {
            return "#FFBC42";
        }
        return "#FC594D";
    };
    const widthP = props.currentValuePercentage != null ? props.currentValuePercentage
        : props.currentValue / props.capacity * 100;
    const width = widthP + "%";
    const currentLevelStyle = {
        width,
        backgroundColor: getColor(widthP),
    };
    const unusedStyle = {
        width: 100 - widthP + "%",
    };
    return (
        <div className={"usage-bar-container"}>
            <div className={"usage-bar"}>
                <div
                    className={"used-part"}
                    style={{
                        width: widthP === 0 ? undefined : width,
                        border: widthP === 0 ? "none" : undefined,
                    }}
                >
                    <p>{props.currentValue} {props.unitOfMeasure}</p>
                </div>
                <div className={"current-level"} style={currentLevelStyle}/>
                <div className={"unused-part"} style={unusedStyle}>
                    <p>{props.capacity - props.currentValue} {props.unitOfMeasure}</p>
                </div>
            </div>
            <div className={"usage-bar__value"}>
                <p>{Math.round(widthP)}%</p>
            </div>
        </div>
    );
};
